import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "background" }
const _hoisted_2 = {
  key: 0,
  class: "title"
}
const _hoisted_3 = {
  key: 1,
  class: "pause-menu"
}

import { ref, onMounted } from "vue";

  const gapBetweenObstacles = 700
  const gapBetweenTopBottomPx = 200
  const gapBetweenTopBottomVariation = 150
  const sizeTopPercent = 25
  const sizeTopPercentVariation = 25
  const obstacleSpeed = 50
  const playerSpeed = 30

  
export default /*@__PURE__*/_defineComponent({
  __name: 'KCGame',
  emits: ['quit'],
  setup(__props, { emit: __emit }) {

  const $emit = __emit

  const gameArea = ref<HTMLDivElement>()
  const player = ref<HTMLDivElement>()
  const obstacle1 = ref<HTMLDivElement>()
  const obstacle2 = ref<HTMLDivElement>()
  const obstacle3 = ref<HTMLDivElement>()
  const obstacle4 = ref<HTMLDivElement>()
  const obstacle5 = ref<HTMLDivElement>()
  const obstacles = [
    {
      ref: obstacle1,
      offset: 0
    }, 
    {
      ref: obstacle2,
      offset: 0
    }, 
    {
      ref: obstacle3,
      offset: 0
    }, 
    {
      ref: obstacle4,
      offset: 0
    }, 
    {
      ref: obstacle5,
      offset: 0
    }
  ]
  const tops:HTMLDivElement[] = []
  const gaps:HTMLDivElement[] = []
  const bottoms:HTMLDivElement[] = []
  let gameAreaRect:DOMRect = new DOMRect()


  let playerY = 250
  let isFlapping = false
  let isFlappingNbFrame = 0
  let isFlappingNbMaxFrame = 6

  let paused = ref(true)


  function initKeyListen() {
    const html:HTMLHtmlElement = document.getElementsByTagName('html')[0]
    function listener(e:KeyboardEvent) {
      if(e.key === 'Escape') {
        html.removeEventListener('keydown', listener)
        $emit('quit')
      }

      if(e.key === 'Enter') {
        paused.value = !paused.value
      }
      
      if(!paused.value) {
        if(e.key === ' ') {
          isFlapping = true
          isFlappingNbFrame = 0
        }
      }
     
      e.preventDefault();
      e.stopPropagation();
    }
    html.addEventListener('keydown', listener)
      
  }

  function initGame() {

    paused.value = true

    gameAreaRect = gameArea.value?.getClientRects() ? gameArea.value?.getClientRects()[0] : new DOMRect()
    const baseOffset = gameAreaRect.width - (gameAreaRect.width / 4)

    for(const obstacle of obstacles) {
      if(obstacle && obstacle.ref.value) {
        tops.push(obstacle?.ref.value.getElementsByClassName('top')[0] as HTMLDivElement)
        gaps.push(obstacle?.ref.value.getElementsByClassName('gap')[0] as HTMLDivElement)
        bottoms.push(obstacle?.ref.value.getElementsByClassName('bottom')[0] as HTMLDivElement)
      }
    }

    for(const obstacleIndex in obstacles) {
      obstacles[obstacleIndex].offset = baseOffset + (parseInt(obstacleIndex) * gapBetweenObstacles) 
    }

    playerY = gameAreaRect.height / 2

    majObstaclePos()
    majPlayerPos()
    randomizeObstacleSize()
  }

  function majPlayerPos() {
    if(!paused.value) {
      if(isFlapping) {
        isFlappingNbFrame++
        if(isFlappingNbFrame >= isFlappingNbMaxFrame) {
          isFlapping = false
        }
        playerY -= playerSpeed
      } else {
        playerY += 1.5*playerSpeed
      }
    }

    player.value?.setAttribute('style', 'top:' +playerY + 'px;')
  }

  function majObstaclePos() {
    for(const obstacleIndex in obstacles) {
      if(!paused.value) {
        obstacles[obstacleIndex].offset -= obstacleSpeed
      }
      if(obstacles[obstacleIndex].offset < -110 ) {
        const lessOffseted = obstacles.reduce(function(prev, curr) {
            return prev.offset > curr.offset ? prev : curr;
        });
        obstacles[obstacleIndex].offset = lessOffseted.offset + gapBetweenObstacles
        randomizeObstacleSize(parseInt(obstacleIndex))
        obstacles[obstacleIndex].ref.value?.setAttribute('style', 'left: ' + obstacles[obstacleIndex].offset + 'px; transition: none;')
      } else {
        obstacles[obstacleIndex].ref.value?.setAttribute('style', 'left: ' + obstacles[obstacleIndex].offset + 'px')
      }
    }
  }

  function randomizeObstacleSize(index?:number) {
    if(index !== undefined) {
      let sizeTopPercentTemp = sizeTopPercent + (sizeTopPercentVariation * Math.random() )
      let gapBetweenTopBottomPxTemp = gapBetweenTopBottomPx + ( gapBetweenTopBottomVariation * Math.random())

      tops[index].setAttribute('style', 'height: ' + parseInt((gameAreaRect.height * (sizeTopPercentTemp/100)).toString()) + 'px')
      gaps[index].setAttribute('style', 'height: ' + parseInt((gapBetweenTopBottomPxTemp).toString()) + 'px')
      bottoms[index].setAttribute('style', 'height: ' + parseInt( ((gameAreaRect.height * (1 - (sizeTopPercentTemp/100))) - gapBetweenTopBottomPxTemp + 5).toString()) + 'px')
    } else {
      for(const obstacleIndex in obstacles) {
        let sizeTopPercentTemp = sizeTopPercent + (sizeTopPercentVariation * Math.random() )
        let gapBetweenTopBottomPxTemp = gapBetweenTopBottomPx + ( gapBetweenTopBottomVariation * Math.random())

        tops[obstacleIndex].setAttribute('style', 'height: ' + parseInt((gameAreaRect.height * (sizeTopPercentTemp/100)).toString()) + 'px')
        gaps[obstacleIndex].setAttribute('style', 'height: ' + parseInt((gapBetweenTopBottomPxTemp).toString()) + 'px')
        bottoms[obstacleIndex].setAttribute('style', 'height: ' + parseInt( ((gameAreaRect.height * (1 - (sizeTopPercentTemp/100))) - gapBetweenTopBottomPxTemp + 5).toString()) + 'px')
      }
    }

    
  }

  function calculateCollision() {
    const playerRect:DOMRect = player.value?.getClientRects() ? player.value?.getClientRects()[0] : new DOMRect()

    if(playerRect.bottom >= gameAreaRect.bottom || playerRect.top <= gameAreaRect.top) {
      initGame()
      return
    }

    for(const top of tops) {
      const topRect:DOMRect = top.getClientRects() && top.getClientRects()[0] ? top.getClientRects()[0] : new DOMRect()
      if(
        (playerRect.x > topRect.x && (playerRect.x < topRect.x + topRect.width) && playerRect.y > topRect.y && (playerRect.y < topRect.y + topRect.height)) || //Top left
        (playerRect.x + playerRect.width > topRect.x && (playerRect.x + playerRect.width < topRect.x + topRect.width) && playerRect.y > topRect.y && (playerRect.y < topRect.y + topRect.height)) //Top right
      ) {
        initGame()
        return
      }
    }

    for(const bottom of bottoms) {
      const bottomRect:DOMRect = bottom.getClientRects() && bottom.getClientRects()[0] ? bottom.getClientRects()[0] : new DOMRect()
      if(
        (playerRect.x > bottomRect.x && (playerRect.x < bottomRect.x + bottomRect.width) && playerRect.y + playerRect.width > bottomRect.y && (playerRect.y + playerRect.width < bottomRect.y + bottomRect.height)) || //Bottom left
        (playerRect.x + playerRect.height > bottomRect.x && (playerRect.x + playerRect.height < bottomRect.x + bottomRect.width) && playerRect.y + playerRect.width > bottomRect.y && (playerRect.y + playerRect.width < bottomRect.y + bottomRect.height)) //Bottom right
      ) {
        initGame()
        return
      }
    }
   
  }

  function gameplayLoop() {
    majObstaclePos()
    majPlayerPos()
    calculateCollision()
  }

  onMounted(() => {
    initKeyListen()
    initGame()
    setInterval(() => {
      if(!paused.value) {
        gameplayLoop()
      }
    },100)
  })



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["game-area", {playBG: !_unref(paused)}]),
      ref_key: "gameArea",
      ref: gameArea
    }, [
      _cache[6] || (_cache[6] = _createStaticVNode("<div class=\"air air1\" data-v-e9b0539e></div><div class=\"air air2\" data-v-e9b0539e></div><div class=\"air air3\" data-v-e9b0539e></div><div class=\"air air4\" data-v-e9b0539e></div><div class=\"stars\" data-v-e9b0539e><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div><div class=\"star\" data-v-e9b0539e></div></div>", 5)),
      _createElementVNode("div", {
        class: "obstacle",
        ref_key: "obstacle1",
        ref: obstacle1
      }, _cache[0] || (_cache[0] = [
        _createElementVNode("div", { class: "top" }, null, -1),
        _createElementVNode("div", { class: "gap" }, null, -1),
        _createElementVNode("div", { class: "bottom" }, null, -1)
      ]), 512),
      _createElementVNode("div", {
        class: "obstacle",
        ref_key: "obstacle2",
        ref: obstacle2
      }, _cache[1] || (_cache[1] = [
        _createElementVNode("div", { class: "top" }, null, -1),
        _createElementVNode("div", { class: "gap" }, null, -1),
        _createElementVNode("div", { class: "bottom" }, null, -1)
      ]), 512),
      _createElementVNode("div", {
        class: "obstacle",
        ref_key: "obstacle3",
        ref: obstacle3
      }, _cache[2] || (_cache[2] = [
        _createElementVNode("div", { class: "top" }, null, -1),
        _createElementVNode("div", { class: "gap" }, null, -1),
        _createElementVNode("div", { class: "bottom" }, null, -1)
      ]), 512),
      _createElementVNode("div", {
        class: "obstacle",
        ref_key: "obstacle4",
        ref: obstacle4
      }, _cache[3] || (_cache[3] = [
        _createElementVNode("div", { class: "top" }, null, -1),
        _createElementVNode("div", { class: "gap" }, null, -1),
        _createElementVNode("div", { class: "bottom" }, null, -1)
      ]), 512),
      _createElementVNode("div", {
        class: "obstacle",
        ref_key: "obstacle5",
        ref: obstacle5
      }, _cache[4] || (_cache[4] = [
        _createElementVNode("div", { class: "top" }, null, -1),
        _createElementVNode("div", { class: "gap" }, null, -1),
        _createElementVNode("div", { class: "bottom" }, null, -1)
      ]), 512),
      _createElementVNode("div", {
        class: "player",
        ref_key: "player",
        ref: player
      }, null, 512),
      (_unref(paused))
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, " Fransys Bird "))
        : _createCommentVNode("", true),
      (_unref(paused))
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[5] || (_cache[5] = [
            _createTextVNode(" Paused "),
            _createElementVNode("br", null, null, -1),
            _createElementVNode("br", null, null, -1),
            _createTextVNode(" Space to flap"),
            _createElementVNode("br", null, null, -1),
            _createTextVNode(" Enter to un/pause"),
            _createElementVNode("br", null, null, -1),
            _createTextVNode(" Escape to quit"),
            _createElementVNode("br", null, null, -1)
          ])))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}
}

})